var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.5 19L0.674684 0.249998L22.3253 0.25L11.5 19Z"}));
}

ArrowDown.defaultProps = {"viewBox":"0 0 23 19","fill":"var(--theme-color)"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
